import styles from "./MessageModal.module.css";
import { Modal, Button, ButtonToolbar } from "rsuite";
import { useMessageModal } from "./useMessageModal";

function MessageModal() {
  const { display, text, close } = useMessageModal();

  return (
    <>
      <Modal size="xs" open={display} onClose={close}>
        <Modal.Header>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <strong>{text}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={close} color="blue" appearance="primary">
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MessageModal;
